import { render, staticRenderFns } from "./DataAnalysisDetail.vue?vue&type=template&id=13fecda4&scoped=true"
import script from "./DataAnalysisDetail.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDetail.vue?vue&type=script&lang=js"
import style0 from "./DataAnalysisDetail.vue?vue&type=style&index=0&id=13fecda4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fecda4",
  null
  
)

export default component.exports